'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _default$ProductGall;

var _state = require('state');

var _state2 = _interopRequireDefault(_state);

var _themeImages = require('@shopify/theme-images');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultSettings = {
  pageDots: false,
  contain: true
};

var productGalleryThumbsSettings = Object.assign({}, defaultSettings, {
  init: false,
  contain: true,
  pageDots: false,
  prevNextButtons: false,
  groupCells: true
});

var productGallerySettings = Object.assign({}, defaultSettings, {
  pageDots: false,
  lazyLoad: true
});

var homepageHeroSettings = Object.assign({}, defaultSettings, {
  adaptiveHeight: true,
  autoPlay: true,
  wrapAround: true,
  lazyLoad: true
});

var additionalProductImages = Object.assign({}, defaultSettings, {
  pageDots: false,
  cellAlign: 'left',
  prevNextButtons: true,
  imagesLoaded: true,
  mq: {
    'screen and (max-width: 480px)': {
      draggable: true,
      prevNextButtons: false
    }
  }
});

exports.default = (_default$ProductGall = {
  default: defaultSettings
}, (0, _defineProperty3.default)(_default$ProductGall, 'Product Gallery', productGallerySettings), (0, _defineProperty3.default)(_default$ProductGall, 'Product Gallery Thumbs', productGalleryThumbsSettings), (0, _defineProperty3.default)(_default$ProductGall, 'Additional Product Images', additionalProductImages), (0, _defineProperty3.default)(_default$ProductGall, 'Homepage Hero', homepageHeroSettings), _default$ProductGall);